import api from "../api";
import { toast } from 'vue3-toastify'

export default {
  namespaced: true,
  state: {
    showProducts: {},
    showProduct: {},
    setListBraCenter: {},
    getListBraCenter: {},
    paginate: {},
    availableCount: 0,
    pausedCount: 0,
    total: 0,
    showing: 0,
    products: [],
    boxes: []
  },

  getters: {
    products: state => state.showProducts
  },

  actions: {
    async get_products_store({ commit }, payload = []) {
      try {
        await api.post(`/v1/show-products-store`, payload)
          .then((res) => {
            commit("GET_PRODUCT_STORE", res.data);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        console.log(e);
      }
    },

    async set_product_list({ commit }, payload = []) {
      try {
        api.post(`/v1/product-store-list`, payload)
          .then((res) => {
            commit("GET_STORE_LIST", res.data);
          })
          .catch((error) => {
            commit("ERROR_STORE_LIST", error);
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_STORE_LIST", e);
      }
    },

    async set_list_bra_center({ commit }, payload = []) {
      try {
        await api.post(`/v1/set-list-bra-center`, payload)
          .then((res) => {
            commit("GET_ITEM_BRA_CENTER", res.data);

            toast.success("Enviado com sucesso.", {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
          })
          .catch((error) => {
            commit("ERROR_ITEM_BRA_CENTER", error);

            toast.warning(error.response.data.message, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_ITEM_BRA_CENTER", e);
      }
    },

    async get_list_bra_center({ commit }, store_id) {
      try {
        api.get(`/v1/get-list-bra-center/${store_id}`)
          .then((res) => {
            commit("GET_LIST_BRA_CENTER", res.data);
          })
          .catch((error) => {
            commit("ERROR_ITEM_BRA_CENTER", error);

            toast.warning(error.response.data.message, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_ITEM_BRA_CENTER", e);
      }
    },

    removeProducts({ commit, state }, outBoxProducts) {
      commit('SET_PRODUCTS', outBoxProducts);
    }
    

  },
  mutations: {
    /*GET_PRODUCT_STORE(state, data) {
      state.showProducts = data
    },*/
    GET_PRODUCT_STORE(state, data) {
      state.showProducts = data?.products || [];
      state.paginate = data?.paginate;
      state.store = data?.store;
      state.total = data?.total;
      state.showing = data?.showing;
      state.availableCount = data?.availableCount;
      state.pausedCount = data?.pausedCount;
    },

    ERROR_PRODUCT_STORE(state, data) {
      console.log(data)
    },

    SET_PRODUCTS(state, data) {
      state.showProducts = data
    },

    GET_STORE_LIST(state, data) {
      state.showProduct = data;
    },
    ERROR_STORE_LIST(state, data) {
      console.log(data);
    },

    GET_ITEM_BRA_CENTER(state, data) {
      state.setListBraCenter = data;
    },
    GET_LIST_BRA_CENTER(state, data) {
      state.getListBraCenter = data;
    },
    ERROR_ITEM_BRA_CENTER(state, data) {
      console.log(data);
    },
  }
}